module.exports = __webpack_public_path__ + "static/media/blog.3f5e3e4b.png";